module.exports = __webpack_public_path__ + "static/media/AppFeeCollected.f8ac56e6.svg";